import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { LocaleConverterModule, NullCheckModule, UnsortedKeyValueModule } from '@app/_shared';
import { PaymentResultModule } from '@app/_shared/modules/payment-result/payment-result.module';
import { MbPlansRoutingModule } from './mb-plans-routing.module';
import { MbPlansComponent } from './mb-plans.component';
import { SubscriptionActivatedModule } from './components/subscription-activated/subscription-activated.module';
import { PlansLoadingModule } from './components/plans-loading/plans-loading.module';
import { PlansStatusModule } from './components/plans-status/plans-status.module';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';

@NgModule({
  declarations: [
    MbPlansComponent
  ],
  imports: [
    CommonModule,
    MbPlansRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    LocaleConverterModule,
    PaymentResultModule,
    NullCheckModule,
    UnsortedKeyValueModule,
    SubscriptionActivatedModule,
    PlansLoadingModule,
    PlansStatusModule,
    MatRadioModule,
  ], 
  exports: [
    MbPlansComponent
  ]
})
export class MbPlansModule { }
